import { useEffect, useState } from "react";
import { getWishlist, toggleWishlist } from "../utils/wishlist";
import { addToCart } from "../utils/cart";
import { useNavigate } from "react-router-dom";
import "./Wishlist.css";
import { MdOutlineAddShoppingCart } from "react-icons/md";
import { IoHeartDislikeSharp } from "react-icons/io5";

export default function Wishlist() {
  const [wishlist, setWishlist] = useState([]);
  const navigate = useNavigate();

  useEffect(() => {
    setWishlist(getWishlist());
  }, []);

  const handleAddToCart = (item) => {
    addToCart(item);
    toggleWishlist(item);
    setWishlist(getWishlist());
    navigate("/cart");
  };

  const handleRemove = (item) => {
    toggleWishlist(item);
    setWishlist(getWishlist());
  };

  if (!wishlist.length) {
    return <h2 className="empty-wishlist">Wishlist is empty 🤍</h2>;
  }

  return (
    <div className="page-container">
      <h2 style={{ textAlign: "center", fontSize: "32px", marginTop: "20px" }}>
        MY FAVORITES🖤
      </h2>
      <div className="product-grid">
        {wishlist.map((item) => (
          <div key={item.id} className="product-wishlist">
            <div className="image-wrapper">
              <img src={`/dress${item.id}.png`} alt={item.name} />
            </div>
            <h3>{item.name}</h3>
            <p>₹{item.price}</p>
            <div className="icons">
              <MdOutlineAddShoppingCart
                className="add-cart-icon"
                onClick={() => handleAddToCart(item)}
              />

              <IoHeartDislikeSharp
                className="r-w"
                onClick={() => handleRemove(item)}
              />
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
